import { render, staticRenderFns } from "./testimonial-card3.vue?vue&type=template&id=7e4fe274&scoped=true&"
import script from "./testimonial-card3.vue?vue&type=script&lang=js&"
export * from "./testimonial-card3.vue?vue&type=script&lang=js&"
import style0 from "./testimonial-card3.vue?vue&type=style&index=0&id=7e4fe274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4fe274",
  null
  
)

export default component.exports